import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import HazmatForm from "../Hazmat/HazmatForm";
import HazmatCard from "../Hazmat/HazmatCard";
import SwitchWithLabel from "../../common/CustomSwitch";

const HazmatDetails = ({
  classes,
  openHazmatEntryForm,
  showHazmatCards,
  hazmatInfo,
  saveHazmatEntry,
  handleHazmatEdit,
  handleHazmatCardDelete,
  isAddHazmatClicked,
  closeHazmatForm,
  handleChange,
  hazmatArray,
  addHazmatEntry,
  editInfo,
  packageTypeList,
  errorInfo,
}) => {
  const getTotalHazmatWeight = () => {
    if (hazmatArray.length > 0) {
      return hazmatArray.reduce(
        (accumulator, hazmatData) => accumulator + parseInt(hazmatData.weight),
        0
      );
    }
    return 0;
  };

  const isHazmatEntryCollapsedWithError = () => {
    return editInfo.isHazmat && errorInfo.isHazmat && !openHazmatEntryForm;
  };
  return (
    <div id="hazmatDetails">
      <SwitchWithLabel
        rowLabel="Hazardous Material"
        onChange={handleChange("isHazmat")}
        value={editInfo.isHazmat}
      />
      <div
        className={`${editInfo.isHazmat && classes.hazmatCollapsibleSection} ${
          isHazmatEntryCollapsedWithError() &&
          !hazmatArray.length > 0 &&
          classes.hazmatCollapsibleSectionError
        }`}
      >
        <Collapse in={editInfo.isHazmat}>
          <Collapse in={showHazmatCards}>
            <div>
              {hazmatArray.map((hazmatObj, index) => (
                <HazmatCard
                  key={`hazmatCard_${index}`}
                  saveHazmatEntry={saveHazmatEntry}
                  handleHazmatEdit={handleHazmatEdit}
                  handleHazmatCardDelete={handleHazmatCardDelete}
                  hazmatInfo={hazmatObj}
                  closeHazmatForm={closeHazmatForm}
                  index={index}
                  packageWeight={editInfo.weight}
                  totalHazmatWeight={getTotalHazmatWeight()}
                  packageTypeList={packageTypeList}
                />
              ))}
            </div>
          </Collapse>
          {openHazmatEntryForm && (
            <div>
              <HazmatForm
                saveHazmatEntry={saveHazmatEntry}
                hazmatInfo={hazmatInfo}
                closeHazmatForm={closeHazmatForm}
                packageWeight={editInfo.weight}
                totalHazmatWeight={getTotalHazmatWeight()}
              />
            </div>
          )}
          {!openHazmatEntryForm && !isAddHazmatClicked && (
            <div className={classes.hazmatContainer}>
              <Button
                autoFocus
                color="primary"
                variant="outlined"
                className={classes.actionButton}
                onClick={addHazmatEntry}
              >
                add hazmat entry
              </Button>
            </div>
          )}
        </Collapse>
      </div>
    </div>
  );
};

export default withStyles(styles)(HazmatDetails);
